import { ApiUrls } from '../endpoints';
import api from '../createApiClient';

export const getCountries = async () => {
  try {
    const dataUrl = `${ApiUrls.base}/countries`;
    const response = await api.get(dataUrl);
    return response.data;
  } catch (error) {
    console.error('Error fetching countries:', error);
    throw error;
  }
};

export const getStates = async (countryCode) => {
  try {
    const dataUrl = `${ApiUrls.base}/states/${countryCode}`;
    const response = await api.get(dataUrl);
    return response.data;
  } catch (error) {
    console.error('Error fetching states:', error);
    throw error;
  }
};
